import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { MdCheck } from "react-icons/md";
import { PopupModal } from "../alert/alert.Dismiss";
import { CONFIRM_BALANCE } from "../../../graphql/orderGroup/mutation";

const ConfirmBalance = ({ setSelectedIds, idIn }) => {
    const [content, setContent] = useState('');
    const [gbColor, setBgColor] = useState('');
    const [centered, setCentered] = useState('');
    const [title, setTitle] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const filter = useMemo(() => { return { id: idIn} }, [idIn]);


    const handleModal = ({ newTitle, newCentered, newContent, newBgColor }) => {
        setModalShow(true)
        setTitle(newTitle);
        setCentered(newCentered);
        setContent(newContent);
        setBgColor(newBgColor);
    }

    return (
        <>
            <Button
                className="w-100 text-left"
                variant="light"
                disabled={idIn?.length >= 1 ? false : true}
                // style={{ background: COLOR_APP, border: 'none' }}
                onClick={() => handleModal({
                    newTitle: "ແຈ້ງຮັບຍອດ",
                    newCentered: "ສົ່ງຂໍຄວາມຮັບຍອດລູກຄ້າທາງ Messenger",
                    newContent: "ລະບົບຈະທະຍ່ອຍສົ່ງຂໍຄວາມ ຈຳນວນການຮ້ອງຂໍແຕ່ລະຄັ້ງຕ້ອງບໍ່ເກີນ50ອໍເດີ....", newBgColor: "bg-success text-white"
                })}
            > <MdCheck />ແຈ້ງຮັບຍອດ</Button>
            <PopupModal
                show={modalShow}
                // onHide={() => { setSelectedIds([]); setModalShow(false) }}
                onCancel={() => { setSelectedIds([]); setModalShow(false) }}
                title={title}
                centered={centered}
                content={content}
                bgColor={gbColor}
                apiPath={CONFIRM_BALANCE}
                filter={filter}
            />
        </>
    );
};

export default ConfirmBalance;
